jQuery(document).ready(function($) {
  if (window.location.pathname === '/') {
    var floatingButton = $('<a href="#section-template--19219763167561__029d9e04-e02e-438d-9026-ad3d361232b2" class="purchase button btn-buy fb-btn">GET LASTING RELIEF</a>');
    $("body").append(floatingButton);

    var heroSectionHeight = $(".custom-hero-section").height();
    $(window).scroll(function() {
      if ($(window).scrollTop() > heroSectionHeight) {
        floatingButton.css("bottom", "20px");
      } else {
        floatingButton.css("bottom", "-100px");
      }
    });
  }
});